(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/slicedToArray", "@babel/runtime/helpers/objectWithoutProperties", "react", "prop-types", "classnames", "@blueprintjs/core", "../../modules/Auth", "../../utils/translate", "../NavBarItemDesktop", "../NavBarItemTablet", "../../modules/Auth/components/LoginForm/LoginFormRenderer"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/slicedToArray"), require("@babel/runtime/helpers/objectWithoutProperties"), require("react"), require("prop-types"), require("classnames"), require("@blueprintjs/core"), require("../../modules/Auth"), require("../../utils/translate"), require("../NavBarItemDesktop"), require("../NavBarItemTablet"), require("../../modules/Auth/components/LoginForm/LoginFormRenderer"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.slicedToArray, a.objectWithoutProperties, a.react, a.propTypes, a.classnames, a.core, a.Auth, a.translate, a.NavBarItemDesktop, a.NavBarItemTablet, a.LoginFormRenderer), a.LoginButton = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h, i, j, k, l, m) {
  "use strict";

  var n = require("@babel/runtime/helpers/interopRequireWildcard"),
      o = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.LoginButton = void 0, b = o(b), c = o(c), d = o(d), e = n(e), f = o(f), g = o(g), j = o(j), k = o(k), l = o(l), m = o(m);

  var p = function p(a) {
    var f = a.authenticated,
        j = a.isMobileSized,
        n = a.isPhoneSized,
        o = a.logoutAction,
        p = a.translate,
        q = a.allowUserRegistration,
        r = a.render,
        s = void 0 === r ? m.default : r,
        t = (0, d.default)(a, ["authenticated", "isMobileSized", "isPhoneSized", "logoutAction", "translate", "allowUserRegistration", "render"]);
    var u = (0, e.useState)(!1),
        v = (0, c.default)(u, 2),
        w = v[0],
        x = v[1],
        y = (0, e.useState)(!1),
        z = (0, c.default)(y, 2),
        A = z[0],
        B = z[1],
        C = (0, e.useState)(!1),
        D = (0, c.default)(C, 2),
        E = D[0],
        F = D[1],
        G = j ? l.default : k.default;
    (0, e.useEffect)(function () {
      f && x(!1);
    }, [f]);

    var H = (0, e.useCallback)(function () {
      x(!1), o();
    }, [o]),
        I = function I() {
      return x(function (a) {
        return !a;
      });
    };

    return e.default.createElement(e.default.Fragment, null, e.default.createElement(G, (0, b.default)({}, t, {
      onClick: I
    })), e.default.createElement(h.Overlay, {
      className: (0, g.default)(h.Classes.OVERLAY_SCROLL_CONTAINER, h.Classes.DARK, "modal-signin"),
      isOpen: w,
      onClose: I
    }, e.default.createElement("div", {
      className: (0, g.default)(h.Classes.CARD, h.Classes.ELEVATION_4, "modal-signin__form")
    }, w && !f && e.default.createElement(h.Tabs, {
      id: "login"
    }, e.default.createElement(h.Tab, {
      id: "signin",
      title: p("auth.loginform.title"),
      panel: e.default.createElement(i.LoginForm, {
        onBeforeSubmitting: function onBeforeSubmitting() {
          return F(!0);
        },
        onAfterSubmitting: function onAfterSubmitting() {
          return F(!1);
        },
        translate: p,
        render: s
      })
    }), q && e.default.createElement(h.Tab, {
      id: "signup",
      title: p("auth.signupform.title"),
      panel: A ? e.default.createElement("p", null, p("auth.signupform.done")) : e.default.createElement(i.SignupForm, {
        translate: p,
        showPassword: !1,
        onCreate: function onCreate() {
          return B(!0);
        }
      })
    })), w && f && !E && e.default.createElement("div", {
      id: "logout"
    }, e.default.createElement("p", null, p("auth.logout.confirm.label")), e.default.createElement("div", {
      className: "modal-signin__form-buttons"
    }, e.default.createElement(h.Button, {
      text: p("auth.logout.cancel.button_label"),
      onClick: I,
      minimal: !0
    }), e.default.createElement(h.Button, {
      text: p("auth.logout.confirm.button_label"),
      onClick: H,
      intent: "primary"
    }))))));
  };

  a.LoginButton = p, p.propTypes = {
    authenticated: f.default.bool,
    isMobileSized: f.default.bool,
    isPhoneSized: f.default.bool,
    logoutAction: f.default.func,
    translate: f.default.func
  }, p.defaultProps = {
    authenticated: !1,
    isMobileSized: !1,
    isPhoneSized: !1,
    logoutAction: function logoutAction() {},
    translate: (0, j.default)({
      "auth.loginform.title": "Sign in",
      "auth.signupform.title": "Create an account",
      "auth.signupform.done": "Successfully created",
      "auth.logout.cancel.button_label": "Cancel",
      "auth.logout.confirm.button_label": "Confirm",
      "auth.logout.confirm.label": "Confirm logout",
      "auth.loginform.email.helper": "Type your email",
      "auth.loginform.email.helper_invalid": "Invalid email",
      "auth.loginform.email.label": "Email",
      "auth.loginform.email.info": "required",
      "auth.loginform.email.placeholder": "Email",
      "auth.loginform.password.helper": "Type your password",
      "auth.loginform.password.helper_invalid": "Invalid password",
      "auth.loginform.password.label": "Password",
      "auth.loginform.password.info": "required",
      "auth.loginform.password.placeholder": "Password",
      "auth.loginform.submit": "Signin",
      "auth.loginform.error_generic": "Invalid credentials",
      "auth.signupform.email.label": "Email",
      "auth.signupform.email.info": "required",
      "auth.signupform.email.placeholder": "Email",
      "auth.signupform.email.help": "Type your email",
      "auth.signupform.submit": "signup"
    })
  };
  a.default = p;
});